import { createRouter, createWebHistory } from 'vue-router';
import store from './store/index';
import Upload from './components/Upload.vue';

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH),
  routes: [
    ...store.state.routes.routes,
    {
      path: '/demo-upload',
      name: 'Upload',
      component: Upload,
      meta: { authRequired: true },
    },
  ],
});

router.beforeEach((to, _from, next) => {
  if (to.name !== 'Login' && to.meta?.authRequired && !store.state.users.user) {
    next({ name: 'Login' });
    return;
  }

  document.title = `${to.name} | ${process.env.VUE_APP_TITLE}`;

  next();
});

export default router;
